
define('text!editor/edit/layers/add/directions/index.html',[],function () { return '<div id="calculatingRoute" data-bind="visible: calculatingRoute">\r\n    <h5>Calculating Route...</h5>\r\n</div>\r\n<div data-bind="compose: content"></div>';});

